import * as i from 'types';

export const filterSeries = (series: i.Serie[]) => (
  series.filter(({ featureOnWeb }) => featureOnWeb)
);
